<template>
  <v-dialog v-model="dialog" persistent width="1000">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-icon>refresh</v-icon> Reprogramación de vacaciones
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form
        v-model="valid"
        ref="form"
        lazy-validation
        @submit.prevent="
          agregarReprogramacion(
            form.fecha_desde_rep,
            form.fecha_hasta_rep,
            total_dias_solicitados
          )
        "
      >
        <v-card-text>
          <v-container grid-list-md style="min-width: 100%;" class="py-0 px-3">
            <p class="texto">
              <b class="texto">Fecha desde: </b>{{ this.form.fecha_desde }}
              <br />
              <b class="texto">Fecha hasta: </b>{{ this.form.fecha_hasta
              }}<br />
              <b class="texto">Días para reprogramar: </b
              >{{ this.form.total_dias }}<br />
            </p>
            <p>
              <b>Datos de la reprogramación: </b>
            </p>

            <v-layout wrap>
              <v-flex md6>
                <v-autocomplete
                  class="text-field-reducido-border"
                  :items="motivos_reprogramacion"
                  item-value="valor"
                  item-text="valor"
                  v-model="form.motivo_reprogramacion"
                  label="Motivo de la reprogramación"
                  maxlength="150"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex md6>
                <v-textarea
                  v-if="form.motivo_reprogramacion == 'Otros'"
                  v-model="form.justificacion_reprogramacion"
                  class="text-field-reducido-border"
                  rows="1"
                  label="Justificación de la reprogramación"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  auto-grow
                >
                </v-textarea>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <p><strong>Ingrese la fecha de su reprogramación: </strong></p>
            </v-layout>
            <v-layout wrap>
              <v-flex md4>
                <v-text-field
                  class="text-field-reducido-border"
                  @input="calculaDiferenciaDias()"
                  @change="calculaDiasHabiles()"
                  type="date"
                  v-model="form.fecha_desde_rep"
                  label="Fecha inicio"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  class="text-field-reducido-border"
                  @input="calculaDiferenciaDias()"
                  @change="calculaDiasHabiles()"
                  type="date"
                  v-model="form.fecha_hasta_rep"
                  label="Fecha fin"
                  :rules="$validate(['required'])"
                  required
                  outline
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  class="text-field-reducido-border"
                  v-if="form.fecha_desde_rep && form.fecha_hasta_rep"
                  v-model="total_dias_solicitados"
                  label="Días"
                  disabled
                  outline
                  clearable
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  block
                  type="submit"
                  :disabled="!form.fecha_desde_rep || !form.fecha_hasta_rep"
                >
                  <v-icon>arrow_downward</v-icon>
                  Registrar
                </v-btn>
              </v-flex>
            </v-layout>
            <!-- <v-layout wrap>
							<v-radio-group
								v-model="form.radio_data"
								row
                required
								:rules="[
                    (v) => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    },
                  ]"
								>
								<v-flex xs4>
									<v-radio label="Todo el día" :value="0"></v-radio>
								</v-flex>
								<v-flex xs4>
									<v-radio label="Solo mañana" :value="1"></v-radio>
								</v-flex>
								<v-flex xs4>
									<v-radio label="Solo tarde" :value="2"></v-radio>
								</v-flex>
                
								</v-radio-group>
					    </v-layout> -->
          </v-container>
        </v-card-text>

        <v-card-text v-if="lista_reprogramaciones.length > 0">
          <v-container>
            <v-layout wrap>
              <v-flex>
                <v-data-table
                  :items="lista_reprogramaciones"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <!-- <td class="text-xs-center">
                      {{props.item.id}}
                    </td> -->
                    <td class="text-xs-center">
                      {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                    </td>
                    <td class="text-xs-center">
                      {{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
                    </td>

                    <td class="text-xs-center">
                      {{ props.item.dias }}
                    </td>

                    <td class="text-xs-center">
                      <v-btn
                        color="error"
                        icon
                        title="Eliminar"
                        @click.prevent="eliminarReprogramacion(props.item.id)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
                Total días:{{ sumatoria_dias_totales }}
                <!-- Total días:{{ form.total_dias - total_dias_lista_repro  }}  -->
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required">*</small>
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="rgba(14, 187, 178, 0.35)"
            type="submit"
            :loading="loading"
            @click="save"
            :disabled="
              !form.motivo_reprogramacion ||
                sumatoria_dias_totales != form.total_dias
            "
          >
            <v-icon dark>check</v-icon>REPROGRAMAR Y ENVIAR
          </v-btn>
          <!-- <v-btn
            color="rgba(14, 187, 178, 0.35)"
            type="submit"
            :loading="loading"
          >
            <v-icon dark>send</v-icon>ENVIAR
          </v-btn> -->
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      lista_reprogramaciones: [],
      valid: false,
      fecha_desde: null,
      fecha_hasta: null,
      loading: false,
      estado_vacacion: [],

      persona: null,
      saldo: null,
      periodo: null,
      id: null,
      dias_habiles: 0,
      dias_saldo_repro: 0,
      total_dias: 0,
      total_dias_solicitados: 0,
      total_dias_lista_repro: 0,
      sumatoria_dias_totales: 0,
      vector_fecha_desde: [],
      vector_fecha_hasta: [],
      headers: [
        // {
        //     text: "Nro",
        //     sortable: false
        //   },
        {
          text: "Fecha desde",
          sortable: false
        },
        {
          text: "Fecha hasta",
          sortable: false
        },

        {
          text: "Total días",
          sortable: false
        },

        {
          text: "Acción",
          sortable: false
        }
      ],
      motivos_reprogramacion: [
        { id: 1, valor: "Por motivos laborales" },
        { id: 3, valor: "Baja médica" },
        { id: 4, valor: "Otros" }
      ],
      correlativo_ficticio: 1
    };
  },
  async mounted() {
    await this.verEstadoVacacion();

    this.$bus.$on("openDialogReprogramarCronograma", async item => {
      this.form = item;
      this.dialog = true;
      this.fecha_desde = this.form.fecha_desde
        .split("/")
        .reverse()
        .join("-");
      this.fecha_hasta = this.form.fecha_hasta
        .split("/")
        .reverse()
        .join("-");

      this.form.fecha_desde_rep = this.$moment(new Date()).format("YYYY-MM-DD");
      this.form.fecha_hasta_rep = this.$moment(new Date()).format("YYYY-MM-DD");
      await this.calculaDiferenciaDias();
      await this.calculaDiasHabiles();
      await this.calculoSaldoReprogramar();
    });
  },
  methods: {
    async agregarReprogramacion(fecha_desde, fecha_hasta, total_dias) {
      try {
        let correlativo;
        this.total_dias_lista_repro = 0;
        if (fecha_desde && fecha_hasta) {
          correlativo = this.correlativo_ficticio;
          let elemento = {
            fecha_desde: fecha_desde,
            fecha_hasta: fecha_hasta,
            dias: total_dias,
            id: correlativo
          };
          //comprobar que no realizen mas de cinco reprogramaciones

          if (this.lista_reprogramaciones.length + 1 <= 5) {
            //Comprobar que los dias de la reprogramacion no exceda a los dias que se tienen en la vacacion programada,
            if (this.comprobarDiasReprogramacion(elemento.dias)) {
              //comprobar que no coincida con otros permisos, otra vacaciones, que no sea igual o este dentro de un rango de fechas del vector temporal this.lista_reprogramacines, y que la fecha no sea menor a la fechga a la fecha de la vacacion de la que se quiere hacer reprogramaciones
              let rpta = await this.comprobarFechasValidas(
                fecha_desde,
                fecha_hasta
              );
              if (rpta != false) {
                this.lista_reprogramaciones.push(elemento);
                this.total_dias_lista_repro =
                  parseInt(this.form.total_dias) -
                  this.calculaSumatoriaListaReprogramaciones();
                this.sumatoria_dias_totales =
                  this.form.total_dias - this.total_dias_lista_repro;
                this.correlativo_ficticio++;
              }
            } else {
              this.$message.warning(
                `Excede el total de los días con los que cuenta para reprogramar`
              );
            }
          } else {
            this.$message.warning(`Solo puede realizar 5 reprogramaciones`);
          }

          this.form.fecha_desde_rep = null;
          this.form.fecha_hasta_rep = null;
          this.total_dias_solicitados = null;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async adicionarElementosAVector(valor) {
      try {
        let v_fecha_desde = [];
        let v_fecha_hasta = [];

        if (this.lista_reprogramaciones.length > 0) {
          this.lista_reprogramaciones.forEach(element => {
            v_fecha_desde.push(element.fecha_desde);
            v_fecha_hasta.push(element.fecha_hasta);
          });
        } else {
          v_fecha_desde = [];
          v_fecha_hasta = [];
        }

        if (valor == 1) {
          return v_fecha_desde;
        }
        if (valor == 2) {
          return v_fecha_hasta;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async comprobarFechasValidas(fecha_desde_nueva, fecha_hasta_nueva) {
      try {
        let rpta = true;
        let bandera_vector = 1;
        let p_vector_fecha_desde = [];
        let p_vector_fecha_hasta = [];
        let p_vector_fecha_desde2;
        let p_vector_fecha_hasta2;
        //armando variables para enviar a la funcion
        if (this.lista_reprogramaciones.length == 0) {
          bandera_vector = 0;
        }

        if (this.lista_reprogramaciones.length > 0) {
          p_vector_fecha_desde = await this.adicionarElementosAVector(1);
          p_vector_fecha_hasta = await this.adicionarElementosAVector(2);
          if (p_vector_fecha_desde.length != p_vector_fecha_hasta.length) {
            p_vector_fecha_hasta.pop();
          }

          //convirtiendo en cadena
          p_vector_fecha_desde2 = p_vector_fecha_desde.toString();
          p_vector_fecha_hasta2 = p_vector_fecha_hasta.toString();

          p_vector_fecha_desde2 = "{" + p_vector_fecha_desde2 + "}";
          p_vector_fecha_hasta2 = "{" + p_vector_fecha_hasta2 + "}";
        } else {
          p_vector_fecha_desde2 = null;
          p_vector_fecha_hasta2 = null;
        }
        //${p_vector_fecha_desde},${p_vector_fechas_hasta}
        let respuesta;
        if (this.lista_reprogramaciones.length > 0) {
          respuesta = await this.$service.graphql({
            query: `
        query{
                runQuery(consulta:"select vacaciones.fn_valida_fechas_reprogramaciones(${parseInt(
                  this.form.id_vacacion_programada
                )},'${fecha_desde_nueva}','${fecha_hasta_nueva}','${p_vector_fecha_desde2}','${p_vector_fecha_hasta2}',${bandera_vector},${parseInt(
              this.form.rol
            )})"){
                  respuesta
                }
              }
            `
          });
        } else {
          respuesta = await this.$service.graphql({
            query: `
        query{
                runQuery(consulta:"select vacaciones.fn_valida_fechas_reprogramaciones(${parseInt(
                  this.form.id_vacacion_programada
                )},'${fecha_desde_nueva}','${fecha_hasta_nueva}',null,null,${bandera_vector},${parseInt(
              this.form.rol
            )})"){
                  respuesta
                }
              }
            `
          });
        }

        respuesta = respuesta.runQuery.respuesta[0].fn_valida_fechas_reprogramaciones.split(
          "|"
        );
        if (respuesta[0] == "0") {
          this.$message.warning(respuesta[1]);
          rpta = false;
        }
        return rpta;
      } catch (error) {
        console.log(error);
      }
    },
    comprobarDiasReprogramacion(dias) {
      try {
        let suma_repro = 0;
        let bandera = true;
        for (let i = 0; i < this.lista_reprogramaciones.length; i++) {
          const element = this.lista_reprogramaciones[i];
          suma_repro = suma_repro + parseInt(element.dias);
        }
        suma_repro = suma_repro + parseInt(dias);
        if (suma_repro > parseInt(this.form.total_dias)) {
          bandera = false;
        }
        return bandera;
      } catch (error) {
        console.log(error);
      }
    },
    eliminarReprogramacion(id) {
      try {
        let tempList = this.lista_reprogramaciones;
        this.total_dias_lista_repro = 0;
        for (let i = 0; i <= tempList.length; i++) {
          if (tempList[i].id == id) {
            this.sumatoria_dias_totales -= parseInt(tempList[i].dias);
            this.correlativo_ficticio++;
            tempList.splice(i, 1);
            this.form.fecha_desde_rep.splice(i, 1);
            this.form.fecha_hasta_rep.splice(i, 1);

            break;
          }
        }
        //
      } catch (error) {}
    },
    calculaSumatoriaListaReprogramaciones() {
      try {
        let suma_repro = 0;
        for (let i = 0; i < this.lista_reprogramaciones.length; i++) {
          const element = this.lista_reprogramaciones[i];
          suma_repro = suma_repro + parseInt(element.dias);
        }
        return suma_repro;
      } catch (error) {
        console.log(error);
      }
    },
    async calculoSaldoReprogramar() {
      // SELECT "vacaciones".fn_saldo_menos_hijos(p_id_vaca_progra integer)
      let dias = 0;
      let respuesta;
      if (this.fecha_desde != null && this.fecha_hasta != null) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                  query{
                    runQuery(consulta:"select vacaciones.fn_saldo_menos_hijos(${parseInt(
                      this.form.id_vacacion_programada
                    )})"){
                      respuesta
                    }
                  }
                `
          });
          dias = respuesta.runQuery.respuesta[0].fn_saldo_menos_hijos;
        } catch (error) {
          console.log(error);
        }
      }
      this.dias_saldo_repro = dias;
    },
    async calculaDiferenciaDias() {
      try {
        let res;
        let user = this.$storage.get("user");
        if (this.form.fecha_desde_rep && this.form.fecha_hasta_rep) {
     
          res = await this.$service.graphql({
            query: `
						query{
							runQuery(consulta:"select general.fn_cuenta_dias_habiles_por_persona('${this.form.fecha_desde_rep}','${this.form.fecha_hasta_rep}',${user.id_persona})"){
								respuesta
							}
							}
						`
          });
          console.log(
            res.runQuery.respuesta[0].fn_cuenta_dias_habiles_por_persona
          );
          let res2 =
            res.runQuery.respuesta[0].fn_cuenta_dias_habiles_por_persona;

          this.total_dias_solicitados = res2;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async calculaDiasHabiles() {
      // SELECT "control".fn_obtiene_dias_habiles(p_fecha_desde date, p_fecha_hasta date)
      let dias = 0;
      let respuesta;
      if (this.fecha_desde != null && this.fecha_hasta != null) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                  query{
                    runQuery(consulta:"select control.fn_obtiene_dias_habiles('${this.fecha_desde}','${this.fecha_hasta}')"){
                      respuesta
                    }
                  }
                `
          });
          dias = respuesta.runQuery.respuesta[0].fn_obtiene_dias_habiles;
        } catch (error) {
          console.log(error);
        }
      }
      this.dias_habiles = dias;
    },
    close() {
      this.form = {};
      this.loading = false;
      this.valid = false;
      this.lista_reprogramaciones = [];
      this.sumatoria_dias_totales = 0;
      this.$bus.$emit("closeDialogReprogramacion");

      this.dialog = false;
    },

    async verEstadoVacacion() {
      let user = this.$storage.get("user");
      let id_funcionario = user.id_funcionario;
      let id_persona = user.id_persona;
      try {
        let res = await this.$service.graphql({
          query: `	
				query{
                  vEstadoVacacions(id_persona: ${id_persona}){
                    rows{
                      dias_saldo
                      dias_asignados
                      dias_utilizados
                      dias_programados
                      dias_cta_vacacion
                      id
                      id_estado
                      id_persona
                      gestion_desde
                      gestion_hasta
                      cas
                      estado
                      total_dias_saldo
                    }
                  }
                } 
					`
        });

        this.estado_vacacion = res.vEstadoVacacions.rows;
        this.persona = this.estado_vacacion[0].id_persona;
        this.saldo = this.estado_vacacion[0].dias_saldo;
        // this.periodo = this.estado_vacacion[0].periodo;
        this.id = this.estado_vacacion[0].id;
        //this.sumar_horas_compensa(this.permiso_compensacion);
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      let user = this.$storage.get("user");
      let respuesta;
      try {
        if (this.form.motivo_reprogramacion == "Otros") {
          this.form.motivo_reprogramacion = this.form.justificacion_reprogramacion;
        }
        for (let j = 0; j < this.lista_reprogramaciones.length; j++) {
          const element = this.lista_reprogramaciones[j];
          if (this.form.rol == 42) {
            respuesta = await this.$service.graphql({
              query: `
              query{
              runQuery(consulta:"select vacaciones.fn_registra_vacacion_reprogramada(${parseInt(
                this.form.id_vacacion_programada
              )},'${element.fecha_desde}','${element.fecha_hasta}',${parseInt(
                user.id
              )},'${this.form.motivo_reprogramacion}')"){
                respuesta
              }
            }
            `
            });
          } else {
            respuesta = await this.$service.graphql({
              query: `
              query{
              runQuery(consulta:"select vacaciones.fn_registra_vacacion_reprogramada_rrhh(${parseInt(
                this.form.id_vacacion_programada
              )},'${element.fecha_desde}','${element.fecha_hasta}',${parseInt(
                user.id
              )},'${this.form.motivo_reprogramacion}',${parseInt(
                this.form.id_persona
              )})"){
                respuesta
              }
            }
            `
            });
          }
        }

        this.loading = false;
        this.$confirm("Reprogramaciones creadas exitosamente", () => {
          this.lista_reprogramaciones = [];
          this.sumatoria_dias_totales = 0;
        });
        this.close();
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style>
.titulo {
  font-size: 1.07em;
  color: rgb(20, 7, 84);
  font-weight: bold;
}
.texto {
  font-size: 1.07em;
  color: rgb(20, 7, 84);
}
.subtitulo {
  font-size: 1.35em;
  color: rgb(20, 7, 84);
  font-weight: bolder;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
}
.cabecera {
  background-color: rgba(20, 7, 84, 0.35);
  font-size: 1.5em;
  color: rgba(20, 7, 84);
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_uso/dialogs/ReprogramarCronograma.vue